import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import Button from '~components/Button'
import Image from '~components/Image'
import { Section, breakpoints } from '~styles/global'
import RichText from '~components/RichText'
import resolveLink from '../../utils/resolveLink'

const MakerBlock = ({ heading, shortDesc, buttonText, reverse, image,  primary, large, to, className }) => {

  const { mobile } = breakpoints
  console.log(`to`, to)

  return (
    <Section className={className}>
      <div css={css`
        text-align: center;
        order: ${!reverse ? 1 : 2};
        grid-column: span 6;
        display: flex;
        flex-direction: column;
        align-items: center;
        ${mobile} {
          grid-column: span 12;
          order: 2;
        }
      `}>
        <Link to={to}>
          <h1 className="serif" css={css`
            margin-top: 1rem;
            margin-bottom: 0.7em;
            ${mobile} {
              margin-top: 0;
            }
          `}>{heading}</h1>
        </Link>
        <div css={css`
          margin: auto 0 4rem;
					max-width: 400px;
          `}>
          <div css={css`
            margin-bottom: 3rem;
            max-width: 540px;
            ${mobile} {
              margin-bottom: 4rem;
            }
            `}>
              <RichText content={shortDesc}></RichText>
          </div>
          <Button
            primary={primary}
            to={resolveLink('maker', to)}
            large={large}
          >
            More about {buttonText}
          </Button>
        </div>
      </div>
      <div css={css`
          order: ${!reverse ? 2 : 1};
          grid-column: span 6;
          ${mobile} {
            grid-column: span 12;
            order: 1;
            margin-bottom: 4rem;
          }
        `}>
        <Link to={to}>
          <Image asset={image} aspectRatio={1} css={css`
            border-radius: 10px;
            overflow: hidden;
            `}/>
        </Link>
      </div>
    </Section>
  )
}

MakerBlock.propTypes = {
  heading: PropTypes.string,
  shortDesc: PropTypes.array,
  ButtonText: PropTypes.string,
  reverse: PropTypes.bool,
  to: PropTypes.string,
  image: PropTypes.object,
  className: PropTypes.string,
}

MakerBlock.defaultProps = {
  heading: 'defaultHeading',
  buttonText: 'Button Text',
  reverse: false,
}

export default MakerBlock
